import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=0ed8a71b&scoped=true"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"
import style0 from "./ProfileImage.vue?vue&type=style&index=0&id=0ed8a71b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8a71b",
  null
  
)

export default component.exports